var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdling(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.3,200.9c-3.6-4.8-4.7-11-2.9-16.8l12.6-42h-37.1l-22.8,75.9h44.1c3,0,5.9,1.5,7.7,3.9c1.8,2.5,2.3,5.6,1.3,8.5 l-12.6,37.7l49.7-59.6h-24.9C272.5,208.6,266.9,205.8,263.3,200.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M497.7,150.3c-5.7,0-10.2,4.6-10.2,10.2v61.4h-29.1v-71.7c0-5.7-4.6-10.2-10.2-10.2H263.7v-34.9h71.7V94.8 c0-17-13.8-30.7-30.7-30.7H202.3c-17,0-30.7,13.8-30.7,30.7v10.2h71.7V140h-31.6c-4.1,0-8.1,1.3-11.6,3.5l-76.4,51.1 c-6.8,4.4-14.7,6.8-22.8,6.9H69.1c-5.7,0-10.2,4.6-10.2,10.2v92.2H23.5v-61.4c0-5.7-4.6-10.2-10.2-10.2c-5.7,0-10.2,4.6-10.2,10.2 v143.4c0,5.7,4.6,10.2,10.2,10.2c5.7,0,10.2-4.6,10.2-10.2v-61.5h35.4v81.9c0,5.7,4.6,10.2,10.2,10.2h215.1c4.4,0,8.7-1.5,12.3-4.1 L403,332.6c7.1-5.3,15.7-8.2,24.6-8.2h20.5c5.7,0,10.2-4.6,10.2-10.2v-71.7h29.1v61.4c0,5.7,4.6,10.2,10.2,10.2 c5.7,0,10.2-4.6,10.2-10.2V160.5C507.9,154.8,503.3,150.3,497.7,150.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdling);
export default __webpack_public_path__ + "static/media/idling.cd2dee2ecef6ca343c4b724f980b63b7.svg";
export { ForwardRef as ReactComponent };